import { render, staticRenderFns } from "./fadex-component.vue?vue&type=template&id=41a29120&"
import script from "./fadex-component.vue?vue&type=script&lang=js&"
export * from "./fadex-component.vue?vue&type=script&lang=js&"
import style0 from "./fadex-component.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports